import { render, staticRenderFns } from "./SmallEventCard.vue?vue&type=template&id=4b7bf448&scoped=true&"
import script from "./SmallEventCard.vue?vue&type=script&lang=js&"
export * from "./SmallEventCard.vue?vue&type=script&lang=js&"
import style0 from "./SmallEventCard.vue?vue&type=style&index=0&id=4b7bf448&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7bf448",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VIcon,VProgressCircular})
